import { Box, TextField } from "@mui/material";
import { ButtonGroupSelector } from "features/WorklistTools/shared/components/ButtonGroupSelector";
import { CommaNumberInput } from "features/WorklistTools/shared/components/CommaNumberInput";
import {
  ApplyCellNumOption,
  SeedingStrategy,
} from "features/WorklistTools/shared/interfaces";
import React, { useState } from "react";
import { DestPlateInfoState } from "../state";
import { useExternalThawStateProvider } from "../state/StateProvider";

interface WellMappingTableHeaderProps {
  handleApplyCellNumber: (
    option: string | number,
    cellNumber: number | undefined
  ) => void;
  destPlates: DestPlateInfoState[];
}
export const WellMappingTableHeader = ({
  handleApplyCellNumber,
  destPlates,
}: WellMappingTableHeaderProps) => {
  const { externalThawInternalState } = useExternalThawStateProvider();

  const [cellNumber, setCellNumber] = useState<number | undefined>();

  const additionalOptions: ApplyCellNumOption[] = destPlates
    .filter((destPlate) => destPlate.plateBarcode !== "")
    .map((destPlate) => ({
      label: destPlate.plateBarcode,
      value: destPlate.index,
    }));
  const getTransferVolInputLabel = () => {
    return externalThawInternalState.methodSettings.seedingStrategy ===
      SeedingStrategy.CellCount
      ? "Cell Count"
      : "Transfer Vol";
  };
  return (
    <React.Fragment>
      <Box sx={{ marginBottom: "5px" }}>
        <TextField
          value={cellNumber ?? ""}
          onChange={(e) => setCellNumber(Number(e.target.value))}
          size="small"
          InputProps={{
            inputComponent: CommaNumberInput as any,
          }}
          label={getTransferVolInputLabel()}
        />
        <ButtonGroupSelector
          handleApplyCellNumber={handleApplyCellNumber}
          additionalOptions={additionalOptions}
          cellNumber={cellNumber}
        />
      </Box>
    </React.Fragment>
  );
};
